export const iconFontAwesomeArrowsUpRightFromSquare = (
	<i className="fa-solid fa-up-right-from-square"></i>
);
